import React from 'react';

import { Icon } from '~/packages/common-frontend/components/icons';
import { GlobalNavRouterLinkItem } from '~/packages/common-frontend/layout';

export const DataPipelineNavItem = (): React.ReactElement => {
  return (
    <GlobalNavRouterLinkItem
      to="/data-pipeline"
      label="Data Pipeline"
      icon={<Icon icon="share-nodes" />}
    />
  );
};
